export default function Avatar({ src, className }) {
  // return (<img src={src}/>);
  return (
    src ?
      <div className={className ? className : 'w-[45px] h-[45px] rounded-full bg-[#999]'}>
        <img src={src}/>
      </div>
      : null
  );
}
